import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import backArrow from "../../../assets/svg/curved_back_arrow.svg";
import { useLocation } from "react-router-dom";

export const FAQNavigation: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <>
      <div className="flex w-full md:w-1/3 md:h-screen pb-10 md:pb-96 lg:pb-20 md:overflow-auto hide-scrollbar">
        <div className="text-white font-medium text-lg md:text-xl md:pl-10 w-full flex flex-col md:h-screen gap-y-6 md:gap-y-14 pt-4 md:pt-10 px-6">
          <div className="h-1 md:h-2 mx-auto md:mx-0">
          <Link
            to="/FAQ"
            className={`${
              currentPath === "/FAQ" ? "hidden" : "block"
            }`}
            draggable={false}
          >
            <img src={backArrow} alt="Back Arrow" />
          </Link>
          </div>
          <Link
            className={`text-center md:text-left ${
              currentPath.includes("/FAQ/whatIsLiifer")
                ? "text-highlight-teal font-bold"
                : ""
            }`}
            to="/FAQ/whatIsLiifer"
            draggable={false}
          >
            {t("FAQ.whatIsLiifer")}
          </Link>
          <Link
            className={`text-center md:text-left ${
              currentPath.includes("/FAQ/howDoesLiiferWork")
                ? "text-highlight-teal font-bold"
                : ""
            }`}
            to="/FAQ/howDoesLiiferWork"
            draggable={false}
          >
            {t("FAQ.howDoesLiiferWork")}
          </Link>
          <Link
            className={`text-center md:text-left ${
              currentPath.includes("/FAQ/whatAreBenefitsOfLiifer")
                ? "text-highlight-teal font-bold"
                : ""
            }`}
            to="/FAQ/whatAreBenefitsOfLiifer"
            draggable={false}
          >
            {t("FAQ.whatAreBenefitsOfLiifer")}
          </Link>
          <Link
            className={`text-center md:text-left ${
              currentPath.includes("/FAQ/whatAreLiiferBucks")
                ? "text-highlight-teal font-bold"
                : ""
            }`}
            to="/FAQ/whatAreLiiferBucks"
            draggable={false}
          >
            {t("FAQ.whatAreLiiferBucks")}
          </Link>
          <Link
            className={`text-center md:text-left ${
              currentPath.includes("/FAQ/orderRelatedQuestion")
                ? "text-highlight-teal font-bold"
                : ""
            }`}
            to="/FAQ/orderRelatedQuestion"
            draggable={false}
          >
            {t("FAQ.orderRelatedQuestion")}
          </Link>
          <Link
            className={`text-center md:text-left ${
              currentPath.includes("/FAQ/anyOtherQuestions")
                ? "text-highlight-teal font-bold"
                : ""
            }`}
            to="/FAQ/anyOtherQuestions"
            draggable={false}
          >
            {t("FAQ.anyOtherQuestions")}
          </Link>
        </div>
      </div>
      <div className="hidden md:block h-11/12 mt-14 mb-24 bg-slate-600 w-0.5"></div>
    </>
  );
};

export default FAQNavigation;
